import React from 'react';
import {IndexLink, Link, withRouter} from 'react-router';

import ReactGA from 'react-ga';
import {isMobile} from 'react-device-detect';
import Splash_Signin from "../commons/splash_signin";
import Loading from 'react-loading';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import axios from 'axios';
import ProjectApply from "../../appcomponents/commons/career/product-apply";
var querystring = require('querystring');

class ProjectTermPage extends React.Component {
    constructor(props) {
        super(props);

        // Add your tracking ID created from https://analytics.google.com/analytics/web/#home/
        ReactGA.initialize('UA-122650632-1');
        // This just needs to be called once since we have no routes in this case.
        ReactGA.pageview(window.location.pathname);

        this.state = {
            rst: [],
            skillArr: [],
            menuShow: false
        }
    }

    componentWillMount = () => {
        this.getProject()
    }

    componentDidMount = () => {
        let url = '/code/api_projects.php?api=postViewedProject';
        var params = Object.assign({},
            {
                id: this.props.params.jk,
            }
        )
        axios.post(url, querystring.stringify(params))
            .then(response => {
                let rst_response = response.data;
                if (parseInt(rst_response.status) === 1) {
                    console.log("postViewedProject")
                }
            });
    }

    componentWillReceiveProps = (nextProps) => {}

    getProject = () => {
        var url = "/code/api_projects.php?api=getProjectDetail";
        var data = new FormData();
        data.append("jk", this.props.params.jk);
        axios.post(url, data)
            .then(response => {
                this.setState({rst: response.data.data}, () => {
                    this.renderSkillArr()
                });
            }).catch(error => {
        });
    }

    renderSkillArr = () => {
        var skillArr = [];
        var job_desired_skill = this.state.rst.skill;
        for (var i = 0; i < job_desired_skill.length; i++) {
            var lable = job_desired_skill[i]['lable'];
            skillArr.push(
                <li key={"skill-"+i} className="profile-skills__skill">
                    <button role="checkbox" aria-checked="false"
                            aria-label="Apache Kafka" id="ember1202"
                            className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view"
                            type="button"><span
                        className="artdeco-pill__text">{lable}</span>
                    </button>
                </li>
            );
        }
        this.setState({skillArr: skillArr});
    }

    handleApplyClick = () => {
        this.props.router.push("/signup")
    }

    mouseClick = (evt) => {
        this.setState({menuShow: !this.state.menuShow})
    }

    mouseOut = (evt) => {
        this.setState({menuShow: false})
    }

    mouseLinkClick = (link, evt) => {
        this.props.router.push(link);
    }

    handleClick = (act) => {
        this.props.router.push(act);
    }

    render() {
        if (parseInt(this.state.rst.length) === 0) {
            return (
                <div id="content">
                    <div className="setting_wrapper">
                        <div className="setting_content">
                            <div className="center_div"><Loading type='spinningBubbles' color='rgba(82, 158, 204, 1)' width={20} height={20}/></div>
                        </div>
                    </div>
                </div>
            );
        }

        // params for popover
        let item = this.state.rst

        let link = "https://versity.co/post-feed/"+this.props.params.jk;
        let estimate = this.state.rst.estimate ? this.state.rst.estimate + " hours" : ""
        if (this.state.rst.estimate && parseInt(this.state.rst.estimate) === 1) {
            estimate = this.state.rst.estimate ? this.state.rst.estimate + " hour" : ""
        }
        let weekly = this.state.rst.weekly ? this.state.rst.weekly + " weeks" : ""
        let hours = this.state.rst.hours ? this.state.rst.hours + " hours per week" : ""
        let cost = parseInt(this.state.rst.to_pay) !== 2 ? this.state.rst.cost + " " : this.state.rst.cost + " per week"
        let ago = this.state.rst.ago
        let cost_extent = this.state.rst.cost_extent
        let apprx = this.state.rst.apprx
        let types = parseInt(this.state.rst.to_pay) !== 2 ? "Onetime Project" : "Ongoing Project"

        //View Post
        let company = this.state.rst
        let f_char = company.name_company.substring(0, 1).toUpperCase()
        let avatar =  company.avata ? company.avata :  f_char
        let imgUrl = company.banner ? company.banner : '/static/img/appimg/default-banner.png';

        if (isMobile) {
            return (
                <div id="splash" className="mobile-page page_other">
                    <div className="advertise_boxx" id="a_project_mobile">
                        <div className={"block-001 row mr0"}>
                            <Link to="/"><img className={"img_logo"} style={{width: "90px"}}
                                              src="/static/img/appimg/top_login_h_logo.png"/></Link>
                            <div className={"mobile-dropdown"}>
                                <svg onClick={() => this.mouseClick()} xmlns="http://www.w3.org/2000/svg"
                                     viewBox="0 0 30 30" width="30" height="30" focusable="false">
                                    <title>Menu</title>
                                    <path stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                          strokeMiterlimit="10" d="M4 7h22M4 15h22M4 23h22"></path>
                                </svg>
                                <ul onMouseOut={() => this.mouseOut()} onMouseLeave={() => this.mouseOut()}
                                    className={this.state.menuShow ? "mobile-menu" : "hide-el mobile-menu"}>
                                    <li onClick={() => this.mouseLinkClick("/employers/signup")}><span>Join</span></li>
                                    <li onClick={() => this.mouseLinkClick("/projects/signin")}><span>Sign in</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="a_project_mobile">
                        <div className="container root-linkedin" id="root-linkedin">
                            <div className="scaffold-layout__row scaffold-layout__content scaffold-layout__content--main">
                                <main id="main" className="scaffold-layout__main">
                                    <div>
                                        <img
                                            src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                                            className="hidden" data-elementtiming="true" alt="" role="none"/>
                                        <section id="ember3348" className="artdeco-card ember-view pv-top-card">
                                            <div className="live-video-hero-image"
                                                 style={{minHeight: "195.5px", maxHeight: "195.5px"}}>
                                                <div tabIndex="0" aria-label="Profile background"
                                                     className="profile-background-image">
                                                    <div className="profile-background-image__image-container">
                                                        <img
                                                            className="profile-background-image__image relative full-width full-height"
                                                            id="profile-background-image-target-image"
                                                            alt="Background Image"
                                                            src={imgUrl}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="ph5 pb5">
                                                <div className="display-flex pv-top-card--reflow">
                                                    <div className="pv-top-card--photo text-align-left">
                                                        <div className="pv-top-card__photo-wrapper ml0">
                                                            <div
                                                                className="presence-entity presence-entity--size-9 pv-top-card__image">
                                                                {parseInt(avatar.length) === 1 ?
                                                                    <span>{f_char}</span>
                                                                    :
                                                                    <img title="Avatar"
                                                                         src={avatar}
                                                                         className="presence-entity__image  pv-top-card__photo no-radius lazy-image ghost-person ember-view"/>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="display-blok mt2 pv-top-card--reflow">
                                                    <div className="flex-1 mr5 pv-top-card__list-container">
                                                        <ul className="pv-top-card--list inline-flex align-items-center">
                                                            <li className="inline t-24 t-black t-normal break-words">
                                                                {this.state.rst.title}
                                                            </li>
                                                        </ul>
                                                        <h2 className="mt1 t-18 t-black t-normal break-words">
                                                            {this.state.rst.name_company}
                                                        </h2>
                                                        <div className="text-left slist mt2" dangerouslySetInnerHTML={{__html: this.state.rst.applied_students}}></div>
                                                    </div>
                                                    <div>
                                                        <ul className="pv-top-card--experience-lists text-center align-items-flex-end">
                                                            <li>&nbsp;</li>
                                                            <li>
                                                                <div className="btn btn_confirm text-info mrlr-10"
                                                                     onClick={this.handleApplyClick.bind(this)}>Apply</div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                    <div className="scaffold-layout--static">
                                        <div className="scaffold-layout__content scaffold-layout__content--main">
                                            <main id="sub-main" className="scaffold-layout__main">
                                                <div id="ember3367" className="pv-oc ember-view">
                                                    <section id="ember3482"
                                                             className="pv-profile-section pv-about-section artdeco-card p5 mt4 ember-view">
                                                        <div className="pv-profile-section__card-header">
                                                            <h4 className="pv-profile-section__card-heading">
                                                                Role Overview
                                                            </h4>
                                                        </div>
                                                        <p id="ember3483"
                                                           className="pv-about__summary-text mt4 t-14 ember-view">
                                                            {this.state.rst.descript}
                                                        </p>
                                                        <div className="mt5">
                                                            <ul className="profile-skills__skill-list profile-skills__skill-list-full">
                                                                <li className="profile-skills__skill">
                                                                    <div className="t-13 t-bold t-black mb1">Compensation</div>
                                                                    <button role="checkbox" aria-checked="false"
                                                                            aria-label="Apache Kafka" id="ember1202"
                                                                            className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view"
                                                                            type="button"><span
                                                                        className="artdeco-pill__text">{cost_extent}</span>
                                                                    </button>
                                                                </li>
                                                                <li className="profile-skills__skill">
                                                                    <div className="t-13 t-bold t-black mb1">Duration</div>
                                                                    <button role="checkbox" aria-checked="false"
                                                                            aria-label="Require.js" id="ember1203"
                                                                            className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view"
                                                                            type="button"><span
                                                                        className="artdeco-pill__text">&lt; 4 weeks</span>
                                                                    </button>
                                                                </li>
                                                                <li className="profile-skills__skill">
                                                                    <div className="t-13 t-bold t-black mb1">Time commitment
                                                                    </div>
                                                                    <button role="checkbox" aria-checked="false"
                                                                            aria-label="Require.js" id="ember1203"
                                                                            className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view"
                                                                            type="button"><span
                                                                        className="artdeco-pill__text">{apprx}</span>
                                                                    </button>
                                                                </li>
                                                                <li className="profile-skills__skill">
                                                                    <div className="t-13 t-bold t-black mb1">Posted</div>
                                                                    <button role="checkbox" aria-checked="false"
                                                                            aria-label="Require.js" id="ember1203"
                                                                            className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view"
                                                                            type="button"><span
                                                                        className="artdeco-pill__text">{ago}</span>
                                                                    </button>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        {this.state.skillArr.length > 0 ?
                                                            <div id="ember2761" className="ember-view pb15 mt5">
                                                                <div className="t-13 t-bold t-black mb1">Skills and expertise</div>
                                                                <ul className="profile-skills__skill-list">
                                                                    {this.state.skillArr}
                                                                </ul>
                                                            </div>
                                                            : ""}
                                                    </section>
                                                </div>
                                            </main>
                                        </div>
                                        <div className="scaffold-layout__content scaffold-layout__content--main">
                                            <main className="scaffold-layout__main">
                                                <div id="ember83" className="pv-deferred-area mt4 ember-view">
                                                    <div className="pv-deferred-area__content">
                                                        <div className="artdeco-card">
                                                            <section className="pt5 pb3 ph4">
                                                                <h2 className="text-heading-medium">
                                                                    About the company
                                                                </h2>
                                                                <ul className="pv-profile-pymk__list">
                                                                    <li className="pv-pymk-section__member-container">
                                                                        <div
                                                                            className="ember-view pv-pymk-section__member align-items-center mg0 pv-top-card__photo-wrapper photo-small">
                                                                            {parseInt(avatar.length) === 1 ?
                                                                                <span className="small">{f_char}</span>
                                                                                :
                                                                                <img title="Avatar"
                                                                                     src={avatar}
                                                                                     className="presence-entity__image  pv-top-card__photo no-radius lazy-image ghost-person ember-view"/>
                                                                            }
                                                                        </div>
                                                                        <div className="pv-pymk-section__member-cta mt1">
                                                                            <div className="t-13 t-bold t-black mb1">Overview
                                                                            </div>
                                                                            <p className="t-14">
                                                                                {item.tagline}
                                                                            </p>
                                                                        </div>
                                                                    </li>
                                                                    <li className="pv-pymk-section__member-container">
                                                                        <div className="feed-identity-module__widgets mv3">
                                                                            <div id="ember1138"
                                                                                 className="feed-identity-module__entity-list entity-list-wrapper ember-view">
                                                                                <ul className="entity-list row mg0">
                                                                                    <li className="entity-list-items">
                                                                                        <div id="ember1142"
                                                                                             className="entity-item ember-view">
                                                                                            <div id="ember1143"
                                                                                                 className="ember-view full-width">
                                                                                                <div id="ember1144"
                                                                                                     className="ember-view">
                                                                                                    <div
                                                                                                        className="display-flex align-items-baseline">
                                                                                                        <div
                                                                                                            className="text-align-left">
                                                                                                            <div
                                                                                                                className="t-12 t-black t-bold mr2">
                                                                                                                <span>No. of Employee:</span>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <div
                                                                                                            className="feed-identity-widget-item__icon-stat t-12 t-black t-bold flex-1">
                                                                                                            <span>{item.emp_company}</span>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </li>
                                                                                    <li className="entity-list-items">
                                                                                        <div id="ember1142"
                                                                                             className="entity-item ember-view">
                                                                                            <div id="ember1143"
                                                                                                 className="ember-view full-width">
                                                                                                <div id="ember1144"
                                                                                                     className="ember-view">
                                                                                                    <div
                                                                                                        className="display-flex align-items-baseline">
                                                                                                        <div
                                                                                                            className="text-align-left">
                                                                                                            <div
                                                                                                                className="t-12 t-black t-bold mr2">
                                                                                                                <span>Location:</span>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <div
                                                                                                            className="feed-identity-widget-item__icon-stat t-12 t-black t-bold flex-1">
                                                                                                            <span>{item.city_company}</span>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </li>
                                                                                </ul>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                    <li className="pv-pymk-section__member-container">
                                                                        <button
                                                                            onClick={this.handleClick.bind(this, 'company/' + item.id_company)}
                                                                            role="checkbox" aria-checked="false"
                                                                            aria-label="Apache Kafka" id="ember1202"
                                                                            className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view"
                                                                            type="button"><span
                                                                            className="artdeco-pill__text">Learn More</span>
                                                                        </button>
                                                                    </li>
                                                                </ul>
                                                            </section>
                                                        </div>
                                                    </div>
                                                </div>
                                            </main>
                                        </div>
                                    </div>
                                </main>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }

        return (
            <div id="splash" className="page_other pd0">
            <header>
                <div className="header">
                    <div className="splash_logo"><Link to="/"><img alt="VERSITY" src="/static/img/appimg/top_login_h_logo.png"/></Link></div>
                    <Splash_Signin type="0" openDialog={this.props.openDialog} url="/code/apis.php"/>
                </div>
            </header>
            <div id="content" className="no-marging-top">
                <div className="container root-linkedin" id="root-linkedin">
                    <div className="scaffold-layout__row scaffold-layout__content scaffold-layout__content--main">
                        <main id="main" className="scaffold-layout__main">
                            <div>
                                <img
                                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                                    className="hidden" data-elementtiming="true" alt="" role="none"/>
                                <section id="ember3348" className="artdeco-card ember-view pv-top-card">
                                    <div className="live-video-hero-image"
                                         style={{minHeight: "195.5px", maxHeight: "195.5px"}}>
                                        <div tabIndex="0" aria-label="Profile background"
                                             className="profile-background-image">
                                            <div className="profile-background-image__image-container">
                                                <img
                                                    className="profile-background-image__image relative full-width full-height"
                                                    id="profile-background-image-target-image"
                                                    alt="Background Image"
                                                    src={imgUrl}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="ph5 pb5">
                                        <div className="display-flex pv-top-card--reflow">
                                            <div className="pv-top-card--photo text-align-left">
                                                <div className="pv-top-card__photo-wrapper ml0">
                                                    <div
                                                        className="presence-entity presence-entity--size-9 pv-top-card__image">
                                                        {parseInt(avatar.length) === 1 ?
                                                            <span>{f_char}</span>
                                                            :
                                                            <img title="Avatar"
                                                                 src={avatar}
                                                                 className="presence-entity__image  pv-top-card__photo no-radius lazy-image ghost-person ember-view"/>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="display-flex mt2 pv-top-card--reflow">
                                            <div className="flex-1 mr5 pv-top-card__list-container">
                                                <ul className="pv-top-card--list inline-flex align-items-center">
                                                    <li className="inline t-24 t-black t-normal break-words">
                                                        {this.state.rst.title}
                                                    </li>
                                                </ul>
                                                <h2 className="mt1 t-18 t-black t-normal break-words">
                                                    {this.state.rst.name_company}
                                                </h2>
                                                <div className="text-left slist mt2" dangerouslySetInnerHTML={{__html: this.state.rst.applied_students}}></div>
                                            </div>
                                            <div>
                                                <ul className="pv-top-card--experience-lists text-center align-items-flex-end">
                                                    <li>&nbsp;</li>
                                                    <li>
                                                        <div className="btn btn_confirm text-info mrlr-10"
                                                             onClick={this.handleApplyClick.bind(this)}>Apply</div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                            <div className="scaffold-layout--static">
                                <div className="scaffold-layout__content scaffold-layout__content--main-aside">
                                    <main id="sub-main" className="scaffold-layout__main">
                                        <div id="ember3367" className="pv-oc ember-view">
                                            <section id="ember3482"
                                                     className="pv-profile-section pv-about-section artdeco-card p5 mt4 ember-view">
                                                <div className="pv-profile-section__card-header">
                                                    <h4 className="pv-profile-section__card-heading">
                                                        Role Overview
                                                    </h4>
                                                </div>
                                                <p id="ember3483"
                                                   className="pv-about__summary-text mt4 t-14 ember-view">
                                                    {this.state.rst.descript}
                                                </p>
                                                <div className="mt5">
                                                    <ul className="profile-skills__skill-list profile-skills__skill-list-full">
                                                        <li className="profile-skills__skill">
                                                            <div className="t-13 t-bold t-black mb1">Compensation</div>
                                                            <button role="checkbox" aria-checked="false"
                                                                    aria-label="Apache Kafka" id="ember1202"
                                                                    className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view"
                                                                    type="button"><span
                                                                className="artdeco-pill__text">{cost_extent}</span>
                                                            </button>
                                                        </li>
                                                        <li className="profile-skills__skill">
                                                            <div className="t-13 t-bold t-black mb1">Duration</div>
                                                            <button role="checkbox" aria-checked="false"
                                                                    aria-label="Require.js" id="ember1203"
                                                                    className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view"
                                                                    type="button"><span
                                                                className="artdeco-pill__text">&lt; 4 weeks</span>
                                                            </button>
                                                        </li>
                                                        <li className="profile-skills__skill">
                                                            <div className="t-13 t-bold t-black mb1">Time commitment
                                                            </div>
                                                            <button role="checkbox" aria-checked="false"
                                                                    aria-label="Require.js" id="ember1203"
                                                                    className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view"
                                                                    type="button"><span
                                                                className="artdeco-pill__text">{apprx}</span>
                                                            </button>
                                                        </li>
                                                        <li className="profile-skills__skill">
                                                            <div className="t-13 t-bold t-black mb1">Posted</div>
                                                            <button role="checkbox" aria-checked="false"
                                                                    aria-label="Require.js" id="ember1203"
                                                                    className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view"
                                                                    type="button"><span
                                                                className="artdeco-pill__text">{ago}</span>
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </div>
                                                {this.state.skillArr.length > 0 ?
                                                    <div id="ember2761" className="ember-view pb15 mt5">
                                                        <div className="t-13 t-bold t-black mb1">Skills and expertise
                                                        </div>
                                                        <ul className="profile-skills__skill-list">
                                                            {this.state.skillArr}
                                                        </ul>
                                                    </div>
                                                    : ""}
                                            </section>
                                        </div>
                                    </main>
                                    <aside className="scaffold-layout__aside">
                                        <div id="ember83" className="pv-deferred-area mt4 ember-view">
                                            <div className="pv-deferred-area__content">
                                                <div className="artdeco-card">
                                                    <section className="pt5 pb3 ph4">
                                                        <h2 className="text-heading-medium">
                                                            About the company
                                                        </h2>
                                                        <ul className="pv-profile-pymk__list">
                                                            <li className="pv-pymk-section__member-container">
                                                                <div
                                                                    className="ember-view pv-pymk-section__member align-items-center mg0 pv-top-card__photo-wrapper photo-small">
                                                                    {parseInt(avatar.length) === 1 ?
                                                                        <span className="small">{f_char}</span>
                                                                        :
                                                                        <img title="Avatar"
                                                                             src={avatar}
                                                                             className="presence-entity__image  pv-top-card__photo no-radius lazy-image ghost-person ember-view"/>
                                                                    }
                                                                </div>
                                                                <div className="pv-pymk-section__member-cta mt1">
                                                                    <div className="t-13 t-bold t-black mb1">Overview
                                                                    </div>
                                                                    <p className="t-14">
                                                                        {item.tagline}
                                                                    </p>
                                                                </div>
                                                            </li>
                                                            <li className="pv-pymk-section__member-container">
                                                                <div className="feed-identity-module__widgets mv3">
                                                                    <div id="ember1138"
                                                                         className="feed-identity-module__entity-list entity-list-wrapper ember-view">
                                                                        <ul className="entity-list row mg0">
                                                                            <li className="entity-list-items">
                                                                                <div id="ember1142"
                                                                                     className="entity-item ember-view">
                                                                                    <div id="ember1143"
                                                                                         className="ember-view full-width">
                                                                                        <div id="ember1144"
                                                                                             className="ember-view">
                                                                                            <div
                                                                                                className="display-flex align-items-baseline">
                                                                                                <div
                                                                                                    className="text-align-left">
                                                                                                    <div
                                                                                                        className="t-12 t-black t-bold mr2">
                                                                                                        <span>No. of Employee:</span>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div
                                                                                                    className="feed-identity-widget-item__icon-stat t-12 t-black t-bold flex-1">
                                                                                                    <span>{item.emp_company}</span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </li>
                                                                            <li className="entity-list-items">
                                                                                <div id="ember1142"
                                                                                     className="entity-item ember-view">
                                                                                    <div id="ember1143"
                                                                                         className="ember-view full-width">
                                                                                        <div id="ember1144"
                                                                                             className="ember-view">
                                                                                            <div
                                                                                                className="display-flex align-items-baseline">
                                                                                                <div
                                                                                                    className="text-align-left">
                                                                                                    <div
                                                                                                        className="t-12 t-black t-bold mr2">
                                                                                                        <span>Location:</span>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div
                                                                                                    className="feed-identity-widget-item__icon-stat t-12 t-black t-bold flex-1">
                                                                                                    <span>{item.city_company}</span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                            <li className="pv-pymk-section__member-container">
                                                                <button
                                                                    onClick={this.handleClick.bind(this, 'company/' + item.id_company)}
                                                                    role="checkbox" aria-checked="false"
                                                                    aria-label="Apache Kafka" id="ember1202"
                                                                    className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view"
                                                                    type="button"><span
                                                                    className="artdeco-pill__text">Learn More</span>
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    </section>
                                                </div>
                                            </div>
                                        </div>
                                    </aside>
                                </div>
                            </div>
                        </main>
                    </div>
                </div>
            </div>
            </div>
        )
    }
}

ProjectTermPage.propTypes = {
    router: React.PropTypes.shape({
        push: React.PropTypes.func.isRequired
    }).isRequired
};

export default withRouter(ProjectTermPage);


/** WEBPACK FOOTER **
 ** ./src/client/app/homecomponents/pages/product-detail.js
 **/